<template>
  <div>
    <b-form-group
      label="Başlık"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.title"
        placeholder="Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="İçerik"
      label-for="content"
    >
      <quill-editor
        id="content"
        v-model="itemData.translate.content"
        class="bg-white"
        :options="editorOption"
      >
        <div
          id="content_toolbar"
          slot="toolbar"
        >
          <editor-toolbar />
        </div>
      </quill-editor>
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.content" />
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Vizyon & Misyon Başlık"
      label-for="vision_mission_title"
    >
      <b-form-input
        id="vision_mission_title"
        v-model="itemData.translate.vision_mission_title"
        placeholder="Vizyon & Misyon Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.vision_mission_title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Vizyon & Misyon Metin"
      label-for="vision_mission_content"
    >
      <b-form-textarea
        id="vision_mission_content"
        v-model="itemData.translate.vision_mission_content"
        placeholder="Vizyon & Misyon Metin"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.vision_mission_content }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Vizyon Başlık"
      label-for="vision_title"
    >
      <b-form-input
        id="vision_title"
        v-model="itemData.translate.vision_title"
        placeholder="Vizyon Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.vision_title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Vizyon"
      label-for="vision"
    >
      <quill-editor
        id="vision"
        v-model="itemData.translate.vision"
        class="bg-white"
        :options="editorOptionVision"
      >
        <div
          id="content_toolbar_vision"
          slot="toolbar"
        >
          <editor-toolbar />
        </div>
      </quill-editor>
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.vision" />
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Misyon Başlık"
      label-for="mission_title"
    >
      <b-form-input
        id="mission_title"
        v-model="itemData.translate.mission_title"
        placeholder="Misyon Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.mission_title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Misyon"
      label-for="mission"
    >
      <quill-editor
        id="mission"
        v-model="itemData.translate.mission"
        class="bg-white"
        :options="editorOptionMission"
      >
        <div
          id="content_toolbar_mission"
          slot="toolbar"
        >
          <editor-toolbar />
        </div>
      </quill-editor>
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.mission" />
        </div>
      </b-alert>
    </b-form-group>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BAlert, BButton, BFormTextarea,
} from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'

export default {
  name: 'About',
  components: {
    EditorToolbar,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BAlert,
    BButton,
    quillEditor,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: '#content_toolbar',
        },
        theme: 'snow',
      },
      editorOptionVision: {
        modules: {
          toolbar: '#content_toolbar_vision',
        },
        theme: 'snow',
      },
      editorOptionMission: {
        modules: {
          toolbar: '#content_toolbar_mission',
        },
        theme: 'snow',
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
